export const flatPickrConfig = {
  dateFormat: 'd/m/Y',
}
